<template>
  <generic-modal :title="$t('message')" ref="generic_modal">
    <form>
      <div class="field">
        <label class="label">{{ $t("to") }}</label>
        <div class="control">
          <input
            type="text"
            class="input"
            v-model="meta.to"
            :placeholder="$t('destinatary email or phone number')"
          />
        </div>
      </div>
      <div class="field">
        <label class="label">{{ $t("send date") }}</label>
        <div class="control">
          <input type="date" class="input" v-model="meta.send_date" />
        </div>
      </div>
      <div class="field">
        <label class="label">{{ $t("arguments") }}</label>
        <div
          class="field has-addons"
          v-for="(arg, aidx) in meta.arguments"
          :key="aidx"
        >
          <div class="control">
            <div class="button is-info">{{ arg.name }}</div>
          </div>
          <div class="control">
            <input
              class="input"
              type="text"
              :placeholder="$t('default value')"
              v-model="meta.arguments[aidx].default_value"
            />
          </div>
        </div>
      </div>
    </form>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import { put, get, post, generate_error_message_text } from "@/utils";
import { cloneDeep } from "lodash";
import GenericModal from "@/components/generic_modal/Index.vue";
import GenericDropdown from "@/components/generic_dropdown/Index.vue";
import bulmaCalendar from "bulma-extensions/bulma-calendar/dist/js/bulma-calendar.min.js";
import "bulma-extensions/bulma-calendar/dist/css/bulma-calendar.min.css";
import moment from "moment";

export default {
  name: "MessageModal",
  components: { GenericModal, GenericDropdown },
  props: {},
  data() {
    return {
      meta: {},
      error: "",
      template_uuid: undefined,
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.to || !v.meta.send_date;
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal(template_uuid) {
      let v = this;
      v.set_initial_state();
      if (template_uuid) {
        get("/outbox/template", { uuid: template_uuid })
          .then((response) => {
            v.template_uuid = template_uuid;
            v.meta.arguments = response.settings.arguments;
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      }
      v.$refs.generic_modal.show_modal();

      setTimeout(() => {
        var calendars = bulmaCalendar.attach('[type="date"]', {
          type: "datetime",
          displayMode: "dialog",
        });

        for (var i = 0; i < calendars.length; i++) {
          // Add listener to select event
          calendars[i].on("select", (date) => {
            v.meta.send_date = moment(date.data.value());
          });
        }

        // // To access to bulmaCalendar instance of an element
        // var element = document.querySelector("#my-element");
        // if (element) {
        //   // bulmaCalendar instance is available as element.bulmaCalendar
        //   element.bulmaCalendar.on("select", function (datepicker) {
        //     console.log(datepicker.data.value());
        //   });
        // }
      }, 200);
    },
    save() {
      let v = this;
      let data = { ...v.meta };
      data.template_uuid = v.template_uuid;
      put("/outbox/message", data)
        .then(() => {
          v.$emit("success");
          v.$refs.generic_modal.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        to: "",
        send_date: "",
        arguments: [],
      };
      v.template_uuid = undefined;
      v.error = "";
    },
    set_provider(provider) {
      let v = this;
      v.meta.provider = provider;
    },
    calculate_variables() {
      let v = this;
      let argums = [];

      if (v.meta.subject) {
        let regex = /\$\{[a-zA-Z_][a-zA-Z_0-9]*\}/gi;
        let _args = v.meta.subject.match(regex);
        if (_args) {
          argums = argums.concat(
            _args.map((v) => {
              return { name: v, default_value: "" };
            })
          );
        }
      }

      if (v.meta.message) {
        let regex = /\$\{[a-zA-Z_][a-zA-Z_0-9]*\}/gi;
        let __args = v.meta.message.match(regex);
        if (__args) {
          argums = argums.concat(
            __args.map((v) => {
              return { name: v, default_value: "" };
            })
          );
        }
      }

      let args_ = [];
      for (let index = 0; index < argums.length; index++) {
        const __arg = argums[index];
        let trgt = args_.find((_arg) => {
          return _arg.name == __arg.name;
        });
        if (!trgt) {
          args_.push(__arg);
        }
      }

      if (!v.meta.arguments) {
        v.meta.arguments = [];
      }

      let filtered = v.meta.arguments.filter((arg) => {
        return args_.find((_arg) => {
          return _arg.name == arg.name;
        });
      });
      args_ = args_.map((arg) => {
        let trgt = filtered.find((_arg) => {
          return _arg.name == arg.name;
        });
        if (trgt) {
          return trgt;
        } else {
          return arg;
        }
      });

      v.meta.arguments = cloneDeep(args_);
    },
  },
  mounted() {},
  watch: {
    "meta.subject": function () {
      let v = this;
      v.calculate_variables();
    },
    "meta.message": function () {
      let v = this;
      v.calculate_variables();
    },
  },
};
</script>
<style></style>
